function getFiltersState(state) {
  return {
    headerFilter: state.estadisticasFiltro.filter,
    startFilter: state.estadisticasFiltro.filterStartPeriod,
    endFilter: state.estadisticasFiltro.filterEndPeriod
  };
}

export { getFiltersState };
